import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";

const Generate_Externally_Service_modal = ({
  modalHeadingText,
  show,
  onHide,
}) => {
  const [showModal, setModal] = useState(false);
  return (
    <>
      <Modal
        className="common_modal Certification_Modal"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        show={show}
        onHide={onHide}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>
            <div className="back_div" onClick={() => onHide()}>
              <Common_Back_Btn />
            </div>
            {modalHeadingText}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="white_container customer_section">
            <div className="row">
              <Form.Group className="form_group">
                <Form.Label>Select Date Range</Form.Label>
              </Form.Group>

              <div className="row">
                {/* Lab Room */}
                <div className="col-md-4">
                  <Form.Group className="form_group ">
                    <Form.Control placeholder="Date From : DD/MM/YYYY" />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="form_group ">
                    <Form.Control placeholder="Date To : DD/MM/YYYY" />
                  </Form.Group>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="permission_btn_holder">
              <Button className="permission_btn No_btn">Cancel</Button>
              <Button
                className="permission_btn Yes_btn"
                onClick={() => {
                  setModal(true);
                  onHide();
                }}
              >
                Generate Report
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Certification_Modal
        show={showModal}
        onHide={() => setModal(false)}
        modalHeadingText={"Externally Provided Product & Service"}
        imgSrc={"/assets/images/cerificate/certi.png"}
        btnText={"Download"}
      />
    </>
  );
};

export default Generate_Externally_Service_modal;
